<template>
  <Main :type="type" :title="title"></Main>
</template>

<script>
import Main from './main.vue'

export default {
  components: { Main },
  props: {
    // 业务类型 1:订车工单,2:商户审核
    type: {
      type: Number,
      default: 1,
    },
    // 当有新的{{ title }}时，下列手机号将收到短信推送
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  },
}
</script>
